import { Article } from '@doist/icons/brand'
import * as Theme from '@/Theme'
import { HyperLink } from '@/components/hyper-link/hyper-link'
import { Text } from '@/components/Text/Text'
import type { AutocompleteSearchResult } from '../AutocompleteSearch'

import css from './SearchResult.module.css'
import { Box } from '@/components/Box/Box'

export type SearchResultProps = {
    theme?: typeof Theme.todoist | typeof Theme.twist | typeof Theme.doist
    searchResult: AutocompleteSearchResult
}
export function SearchResult({
    theme = Theme.todoist,
    searchResult,
    ...rest
}: SearchResultProps & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
    return (
        <HyperLink
            className={css.searchResult}
            href={searchResult.href}
            onClick={searchResult.onClick}
            {...rest}
        >
            <Box className={css.icon}>
                <Article width={18} height={18} color="var(--display-onlight-tertiary)" />
            </Box>
            <Box className={css.content}>
                <Text size="minor-base">{searchResult.title}</Text>
                {searchResult.description && (
                    <Text tag="div" size="body-xs" className={css.description}>
                        {searchResult.description}
                    </Text>
                )}
            </Box>
        </HyperLink>
    )
}
